// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"47c5b6bf","165":"67c5e055","435":"4a709bfd","452":"925fe0db"}[chunkId] + ".chunk.js";
};